import _ from 'underscore';
import { CWGererPretWorflowActifModel } from './cwGererPretWorflowActif.model';
import { CWPaginatedCollection } from 'src/core/models/cwPaginated.collection';


/**
 * Collection of Type d'evénements
 */
export class CWGererPretWorkflowActifColl extends CWPaginatedCollection<CWGererPretWorflowActifModel>{

  canViewTreatment: boolean;

  constructor(models?: CWGererPretWorflowActifModel[] | { [key: string]: any }[] | any, options?: { [key: string]: any }) {
    if (!options && !_.isEmpty(models)) {
      options = models;
    }
    options = options || {};
    options.model = options.model || CWGererPretWorflowActifModel;
    super(models, options);
    this.canViewTreatment = true;
    this.url = (): string => {
      return Configuration.restRoot + "/rest/assocircuitevt/type";
    };
    this.sortings = { libelle: true };
    this.paginated = false;
  }
}